import { Component, OnInit, Inject, PLATFORM_ID,ViewChild,ChangeDetectorRef } from '@angular/core';
import { isPlatformServer, isPlatformBrowser,CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SmallFaq } from "../../../shared/small-faq/small-faq";
import { Footer } from "../../../shared/footer/footer";
import { AlwaysThere } from "../../../shared/always-there/always-there";
import { InterestYou } from "../../../shared/interest-you/interest-you";
import { CatalogService } from '../../../modules/catalog/catalog.service';
import { Navbar } from "../../../shared/navbar/navbar";
import { BasketService } from '../../basket/basket.service';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [SmallFaq, Footer, Navbar, AlwaysThere, InterestYou, CommonModule, RouterModule,PdfJsViewerModule],
  templateUrl: './product-detail.html',
  styleUrl: './product-detail.css',
})
export class ProductDetail implements OnInit {
@ViewChild('externalPdfViewer') public externalPdfViewer: any;
  product: any;
  fctList: string[] = [];
  accordionItems: any[] = [];
  engagement: string = '';
  listForfaitUrl = '/';
  listNotIncluded = [
    "Au-delà de 200 correspondants différents par mois, facturation au tarif de 0,33€ TTC/mn, 0,07€ TTC/MMS ou 0,03€ TTC/SMS.",
    "Appels et SMS/MMS depuis et vers l'international.",
    "Appels et SMS/MMS vers les DOM, l'UE.",
    "Internet mobile hors de l'UE et des DOM.",
    "Au-delà de 4h par appel, facturation au tarif de 0,33€ TTC/mn.",
    "Transfert d'appels depuis la France vers un numéro français : 0,33€ TTC/mn, depuis ou vers l'étranger*.",
    "Appels, SMS et MMS vers les numéros spéciaux et numéros courts.",
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private basketService: BasketService,private route: Router,
    private activatedRoute: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    private catalogService: CatalogService,
    private http: HttpClient,private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'virtual_page_view',
        ecommerce: null,
        page_location: 'https://www.youprice.fr/',
        page_path: '/',
        content_group: 'HP',
        user_id: ''
      });
    }
    this.activatedRoute.data.subscribe((data) => {
      const resolved = data['product'];
      if (resolved && resolved['product']) {
        this.applyProduct(resolved['product']);
      } else {
        const params = this.activatedRoute.snapshot.paramMap;
        const rawOperateur = params.get('operateur') || ''; 
        const slug = params.get('slug') || '';
        const operateur = rawOperateur.replace('forfaits-mobile-', '');
        const operateursValides = ['orange', 'sfr', 'bouygues'];
        if (operateur && slug && operateursValides.includes(operateur)) {
          const url = `${slug}-${operateur}`.split('?')[0]; 
          this.getProduct(url);
        } else {
          console.warn('Opérateur inconnu ou paramètres manquants :', operateur);
        }
      }
    });
  }
  openPdf(fileName: string | undefined): void {
    if (!fileName) return;
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.write(`
        <html style="height: 100%; margin: 0; display: flex; align-items: center; justify-content: center; background-color: #f3f4f6;">
          <body style="font-family: Arial, sans-serif; color: #333; text-align: center;">
            <h2 style="color: #F36A2D;">Génération de votre document...</h2>
            <p>Veuillez patienter quelques secondes.</p>
          </body>
        </html>
      `);
      newWindow.document.close(); 
    }
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
      ? `${environment.apiUrlLocal}`
      : `${environment.apiUrl}`;
    const fullPdfUrl = `${apiUrl}/Product/GetFile?id=` + fileName;
    const body = {}; 
    this.http.post(fullPdfUrl, body, { responseType: 'blob' }).subscribe({
      next: (pdfBlob: Blob) => {
        const file = new Blob([pdfBlob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        if (newWindow) {
          newWindow.location.replace(fileURL);
        }
      },
      error: (error) => {
        console.error('Impossible de récupérer le PDF depuis l\'API :', error);
        if (newWindow) {
          newWindow.close(); 
        }
        alert("Le document n'a pas pu être chargé. Veuillez vérifier votre connexion.");
      }
    });
  }
  openRecapPdf(fileName: string | undefined): void {
    if (!fileName) return;
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.write(`
        <html style="height: 100%; margin: 0; display: flex; align-items: center; justify-content: center; background-color: #f3f4f6;">
          <body style="font-family: Arial, sans-serif; color: #333; text-align: center;">
            <h2 style="color: #F36A2D;">Génération de votre document...</h2>
            <p>Veuillez patienter quelques secondes.</p>
          </body>
        </html>
      `);
      newWindow.document.close(); 
    }
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
      ? `${environment.apiUrlLocal}`
      : `${environment.apiUrl}`;
    const fullPdfUrl = `${apiUrl}/Product/GetRecapContrat?id=` + fileName;
    const body = {}; 
    this.http.post(fullPdfUrl, body, { responseType: 'blob' }).subscribe({
      next: (pdfBlob: Blob) => {
        const file = new Blob([pdfBlob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        if (newWindow) {
          newWindow.location.replace(fileURL);
        }
      },
      error: (error) => {
        console.error('Impossible de récupérer le PDF depuis l\'API :', error);
        if (newWindow) {
          newWindow.close(); 
        }
        alert("Le document n'a pas pu être chargé. Veuillez vérifier votre connexion.");
      }
    });
  }
  getProduct(url: string) {
    this.catalogService.getActiveProductByUrl(url).subscribe({
      next: (data: any) => {
        const productData = data['product'] ? data['product'] : data;
        this.applyProduct(productData);
        this.updateMeta(data);
      },
      error: (err) => {
        console.error("Erreur de récupération du produit:", err);
        this.route.navigate(['/']);
      }
    });
  }
  private updateMeta(data: any) {
    if (data?.['metaDescription']) {
      this.metaService.updateTag({ 
        name: 'description', 
        content: data['metaDescription'] 
      }, "name='description'"); 
    }
    if (data?.['metaTitle']) {
      this.titleService.setTitle(data['metaTitle']);
    }
    this.cdr.detectChanges();
  }
  private applyProduct(product: any) {
    this.product = product;
    if (!this.product) return;
    switch (this.product?.operateur) {
      case 'orange': this.listForfaitUrl = 'forfaits-mobile-orange'; break;
      case 'sfr': this.listForfaitUrl = 'forfaits-mobile-sfr'; break;
      case 'bouygues': this.listForfaitUrl = 'forfaits-mobile-bouygues'; break;
    }
    const gtmTag2 = {
      event: 'view_item',
      ecommerce: {
        currency: 'EUR',
        items: [{
          item_id: this.product?.id,
          item_name: 'Forfaits ' + this.product?.libelle + ' ' + this.product?.operateur,
          item_category: this.product?.libelle,
          item_category2: this.product?.operateur,
          discount: 0,
          price: this.product?.minTarif
        }]
      }
    };
    const gtmTag3 = {
      zone: 'product',
      productId: this.product?.id,
      categoryId: this.product?.operateur
    };
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(gtmTag2);
      (window as any).dataLayer.push(gtmTag3);
    }
    if (this.product?.fonctionalites) {
      this.fctList = this.product.fonctionalites
        .split(',')
        .map((fct: string) => fct.trim())
        .filter((fct: string) => fct.length > 0);
    }
    this.engagement = (!this.product?.engagementPeriod || this.product.engagementPeriod === 0)
      ? 'Sans engagement'
      : `${this.product.engagementPeriod} mois`;
    const inFranceList = this.parseList(this.product?.inFrance);
    const inEuropeList = this.parseList(this.product?.inEurope);
    const freeOptionsList = this.parseList(this.product?.freeOptions);
    const payedOptionsList = this.parseList(this.product?.payedOptions);
    if (this.product?.urlName == 'forfait-voyage-300Go-5G-orange') {
      console.log("inEuropeList", inEuropeList);
      var zone = [];
      zone.push('Jusqu’à 26 Go/mois (Go consommés sur votre enveloppe globale, débitréduit et hors forfait au delà, en fonction de la destination*).');
      this.accordionItems = [
        { title: 'En France', isOpen: true, hasList: inFranceList.length > 0, listItems: inFranceList },
        { title: 'UE & DOM', isOpen: false, hasList: inEuropeList.length > 0, listItems: inEuropeList },
        { title: 'Zone 1ter & Zone 2bis', isOpen: false, hasList: inEuropeList.length > 0, listItems: zone },
        { title: 'Non inclus', isOpen: false, hasList: true, listItems: this.listNotIncluded },
        { title: 'Options payantes', isOpen: false, hasList: payedOptionsList.length > 0, listItems: payedOptionsList },
        { title: 'Options gratuites', isOpen: false, hasList: freeOptionsList.length > 0, listItems: freeOptionsList }
      ];
    } else {
      this.accordionItems = [
        { title: 'En France', isOpen: true, hasList: inFranceList.length > 0, listItems: inFranceList },
        { title: 'UE & DOM', isOpen: false, hasList: inEuropeList.length > 0, listItems: inEuropeList },
        { title: 'Non inclus', isOpen: false, hasList: true, listItems: this.listNotIncluded },
        { title: 'Options payantes', isOpen: false, hasList: payedOptionsList.length > 0, listItems: payedOptionsList },
        { title: 'Options gratuites', isOpen: false, hasList: freeOptionsList.length > 0, listItems: freeOptionsList }
      ];
    }
    this.cdr.detectChanges(); 
  }
  private parseList(text: string | undefined): string[] {
    if (!text) return [];
    return text.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }
  toggleItem(item: any): void {
    item.isOpen = !item.isOpen;
  }
  createBasket(product: any) {
    product.operators = product?.operateur;
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'select_item',
        ecommerce: {
          currency: "EUR",
          items: [
              {
                 item_id: product.id,
                 item_name: "Forfaits "+ product.libelle + " "+ product.operators,
                 item_category: product.libelle,
                 item_category2: product.operators,
                 discount: 0,
                 price: product.maxTarif
              }
          ]
        }
      });
    }
    this.basketService.createBasket(product);
  }

}